import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "./lib/LangContext";
import Landing from "./pages/Landing";
import LegalRoute from "./pages/LegalRoute";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/impressum" element={<LegalRoute type="imprint" />} />
            <Route path="/datenschutz" element={<LegalRoute type="privacy" />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
